<template>
    <Button @click="abrir()" class="anexo-btn border-none">
        <div class="flex flex-row align-items-center justify-content-center">
            <i class="pi pi-paperclip mr-3"></i>
            <p>lancamento_{{ lancamento?.idlan }}.pdf</p>
        </div>
    </Button>
    <visualizar-PDF :mostrar="mostrar" :titulo="`Lançamento ${lancamento?.idlan}`" @cancelar="fechar()" v-if="arquivo">
        <PDFViewer :source="this.arquivo" style="height: 60vh; width: 50%" />
    </visualizar-PDF>
</template>

<style>
.pdf-viewer {
    min-width: 0px !important;
    min-height: 0px !important;
}
</style>
<script>
import VisualizarPDF from './VisualizarPdf';
import LancamentosService from './service';
import PDFViewer from 'pdf-viewer-vue';

export default {
    components: { VisualizarPDF, PDFViewer },

    props: {
        lancamento: { type: Object },
    },

    data() {
        return {
            mostrar: false,
            arquivo: [],
        };
    },

    methods: {
        abrir() {
            this.obterPdf();
            this.mostrar = true;
        },

        fechar() {
            if (!this.mostrar) return;

            this.arquivo = null;
            this.mostrar = false;
        },

        obterPdf() {
            this.$store.dispatch('addRequest');
            LancamentosService.obterArquivoLancamento(this.lancamento?.lancamentoId)
                .then((response) => {
                    if (response) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        this.arquivo = window.URL.createObjectURL(blob);
                        this.mostrar = true;
                    }
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },
    },
};
</script>
